import { Button, Flex } from 'antd';
import {
  CATEGORIES,
  DrawerTitleProps,
} from '@src/components/side-bar-menu/worlds/types';
import styles from '../worlds-drawer.module.css';

export default function DrawerTitle({
  activeCategory,
  onCategoryChange,
}: DrawerTitleProps) {
  return (
    <div className={styles.topSection}>
      <h3 className={styles.title}>
        {activeCategory === CATEGORIES.WORLDS ? 'Worlds' : 'Prefabs'}
      </h3>
      <Flex gap={10} className={styles.categoryButtons}>
        {Object.values(CATEGORIES).map((category) => (
          <Button
            key={category as string}
            className={`${styles.categoryButton} ${
              activeCategory === category ? styles.active : ''
            }`}
            onClick={() => onCategoryChange(category)}
          >
            {category === CATEGORIES.WORLDS ? 'Worlds' : 'Prefabs'}
          </Button>
        ))}
      </Flex>
    </div>
  );
}
